import { SubSink } from 'subsink';
import { ProgressSpinnerService } from './../services/progress-spinner.service';
import { Component, OnInit, OnDestroy } from '@angular/core';

/** Global spinner styrd av token-interceptorn (aktiva HTTP-anrop). Blockerar hela sidan med en overlay medan anrop pågår. */
@Component({
  selector: 'app-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss']
})
export class ProgressSpinnerComponent implements OnInit, OnDestroy {
  private _subs = new SubSink();
  public showSpinner = false;

  constructor(private _progressSpinnerService: ProgressSpinnerService) { }

  ngOnInit(): void {
    this._subs.add(
      this._progressSpinnerService.progressSpinner.subscribe(showSpinner => this.showSpinner = showSpinner)
    );
  }

  ngOnDestroy(): void {
    if (this._subs) {
      this._subs.unsubscribe();
    }
  }
}
